"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KEFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_121)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_121`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H29.9298V6.35642H-6V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 17.614H30V24H-6V17.614Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 8H30V16H-6V8Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.6877 3.82453L14.8912 2.99646L11.9649 9.614L9.03856 2.99646L7.24207 3.82453L10.8772 11.9789L7.24207 20.1333L9.03856 20.9614L11.9649 14.3368L14.8912 20.9614L16.6877 20.1333L13.0526 11.9789L16.6877 3.82453Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.1859 4.6035C12.4911 3.84561 11.9648 3.41052 11.9648 3.41052C11.9648 3.41052 11.4385 3.84561 10.7438 4.6035V19.3474C11.4385 20.1053 11.9648 20.5403 11.9648 20.5403C11.9648 20.5403 12.4911 20.1053 13.1859 19.3474V4.6035Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.66663 7.43159V16.5193C9.40347 17.8176 10.3017 18.8842 10.9754 19.593V4.35791C10.3017 5.06668 9.40347 6.13335 8.66663 7.43159ZM15.2631 7.43159C14.5263 6.13335 13.628 5.06668 12.9543 4.35791V19.6C13.628 18.8912 14.5263 17.8246 15.2631 16.5263V7.43159Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.2632 7.43158V16.5193C16.0071 15.2 16.5825 13.6421 16.5825 11.9719C16.5825 10.3018 16.0071 8.75088 15.2632 7.43158ZM8.66671 7.43158V16.5193C7.92285 15.2 7.34741 13.6421 7.34741 11.9719C7.34741 10.3018 7.92285 8.75088 8.66671 7.43158Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_121`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KEFlag };
